import request from 'assets/js/http';

export function queryDlDm(data) {
  // 获取DLDM公司列表
  return request({
    url: '/company/queryDlDm',
    method: 'post',
    data
  });
}
export function editDlDm(data) {
  // 设置DLDM
  return request({
    url: '/company/editDlDm',
    method: 'post',
    data
  });
}

export function queryBu(data) {
  // 查询BU
  return request({
    url: '/company/queryBu',
    method: 'post',
    data
  });
}
